import React from "react";

const HomeContact = () => {
  return (
    <div
      className="text-center p-16 font-serif"
      //   style={{ backgroundColor: "#ffb500" }}
    >
      <div>
        <h1 className="text-center text-3xl font-serif font-semibold">
          St. John's High School
        </h1>
        <div>
          <p>
            Raio, P.O - Raiya Bari, PS - Killa, Udaipur, Gomati Tripura - 799114
          </p>
          <p>+91 9876554321</p>
          <p>saintjohnschool@rediffmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default HomeContact;
